import { Component, Input } from "@angular/core";
import { Development } from "@models/development.model";
import { Project } from "@models/project.model";
@Component({
  selector: "app-project-summary",
  templateUrl: "./project-summary.component.html",
  styleUrls: ["./project-summary.component.scss"],
})
export class ProjectSummaryComponent {
  mapZoomLevel = 9;

  is1280Screen = false;

  @Input()
  set development(development: Development) {
    this._development = development;
  }

  get development(): Development {
    return this._development;
  }

  _development!: Development;

  @Input()
  isMultiDevelopment = false;

  multiDevelopmentTitle = "Various Developments (Multi-Site)";

  multiDevelopmentLocationTitle = "Multiple Locations";

  plannedProjectText =
    "This project is tentatively planned to begin in ${}, dependent on staffing, funding, and other factors.";
  plannedScopeText = "Not applicable";

  isPlannedProject = false;

  isCompletedProject = false;

  @Input()
  set project(project: Project) {
    this._project = project;
    this.is1280Screen = window.innerWidth <= 1280 ? true : false;
  }

  get project(): Project {
    return this._project;
  }

  _project!: Project;
  _projectStatus!: string[];

  @Input()
  set projectStatus(projectStatus: string[]) {
    this._projectStatus = projectStatus;
    this.getPlannedText();
    this.isCompletedProject = this.projectStatus.findIndex((x) => x.toLocaleLowerCase() === "completed") !== -1 ? true :false;
  }

  get projectStatus(): string[] {
    return this._projectStatus;
  }

  getPlannedText(): void {
    this.isPlannedProject = this._projectStatus.every((x) => x.toLocaleLowerCase() === "planned");
    if (this.isPlannedProject) {
      this.plannedProjectText = this.plannedProjectText.replace(
        "${}",
        this._project?.startYear ?? "",
      );
    }
  }
  // getProjectstatus(): void {
  //   this.projectStatus.push(...this._project.schedule.flatMap((x) => x.projectStatus));

  //   this.projectStatus.push(
  //     ...this._project.schedule
  //       .filter((x) => Number(x.percentageCompleted) < 100 && Number(x.percentageCompleted) !== 0)
  //       .flatMap((v) => v.taskName),
  //   );

  //   this.projectStatus = this.projectStatus.filter((item, pos, ar) => ar.indexOf(item) === pos);
  // }
}
